import CheckboxInput from './CheckboxInput';

export {
    CheckboxInput,
};


// WEBPACK FOOTER //
// ./src/components/widget/common/Input/index.ts